import api from './client';
import { Test } from '../types/testData';
import { downloadBlob } from '../utils/download';

export const getTests = async (): Promise<Test[]> => {
  const response = await api.get('/tests');
  return response.data;
};

export const getTest = async (id: number): Promise<Test> => {
  const response = await api.get(`/tests/${id}`);
  return response.data;
};

export const createTest = async (data: Partial<Test>): Promise<Test> => {
  const response = await api.post('/tests', data);
  return response.data;
};

export const updateTest = async (id: number, data: Partial<Test>): Promise<Test> => {
  const response = await api.put(`/tests/${id}`, data);
  return response.data;
};

export const deleteTest = async (id: number): Promise<void> => {
  await api.delete(`/tests/${id}`);
};

export const publishTest = async (id: number): Promise<Test> => {
  const response = await api.patch(`/tests/${id}/publish`);
  return response.data;
};

export const unpublishTest = async (id: number): Promise<Test> => {
  const response = await api.patch(`/tests/${id}/unpublish`);
  return response.data;
};

export const exportTest = async (testId: number, testTitle: string): Promise<void> => {
  const response = await api.get(`/tests/${testId}/export`, { responseType: 'blob' });
  const blob: Blob = response.data instanceof Blob
    ? response.data
    : new Blob([response.data], { type: 'application/json' });
  downloadBlob(blob, `test_${testId}_${testTitle.replace(/[^a-zа-яё0-9]/gi, '_')}.json`);
};

export const importTest = async (file: File): Promise<Test> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/tests/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
